<template>
  <FAQ :faqs="faqs" :wrapper-class="'faqs-lp'" />
</template>

<script setup>
import { onMounted, ref } from "vue";
import FAQ from "./common/FaqPanel.vue";

const props = defineProps({
  config: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

const faqs = ref([]);

onMounted(() => {
  // First check if there are custom FAQs from the database
  if (props.config?.faqs && props.config.faqs.length > 0) {
    faqs.value = props.config.faqs;
    return;
  }

  faqs.value = [
    {
      question: "Why book with Flightfox?",
      answer: "When you book with us, we are here for you every step of the way. To start, we guarantee the lowest prices on flights. Then once you are booked, we are here to support you 24/7 with any questions or issues. This is important for busy travel seasons and group flights when disruptions are common and it helps to have experts on call at all times of day.",
    },
    {
      question: "How we find the lowest price?",
      answer: "This is our specialty at Flightfox. We know all the tricks of the trade to guarantee you the lowest possible prices. Unlike other travel companies, we use both software and humans to search every provider, website and source; even popular consumer websites such as Kayak, Orbitz and Google.",
    },
    {
      question: "How will we support your trip?",
      answer: "We have genuine travel experts based across five continents who provide 24/7 support in many languages. We have helped thousands of people navigate difficult situations; everything from flights missed to flights diverted and cancelled. We are just an email away and support you the entire way.",
    },
  ];
});
</script>
